export const getUniqueId = () => {
  return `${+new Date()}_${Math.floor(Math.random() * 100000 + 1)}`;
};
